import * as React from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Dialog, DialogContent, DialogTitle, TablePagination } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { getStatusElement } from 'pages/c-dad/component/JobAuditTable/JobAuditTable';
import { jobAuditSubJobTableHeader, jobAuditSubSubJobTableHeader } from 'utility/constants';
import CloseIcon from "@mui/icons-material/Close";
import { getJobName, getSubJobType, sortJobAuditList } from 'utility/helper';
import MaxToolTip from 'shared-component/tooltip-max/toolTipMax';
import { JobStatusFillToolTipContent } from 'pages/data-fill/components/FillToolTipContent';
import { customFormat } from 'utility/dayjsUtils';
import dayjs from 'dayjs';
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

const utz = dayjs.tz.guess();

function Row(props: any) {
  const { row, handleHeaderDataClick, handleRawDataClick, reTriggerErrorHeaderDataJob, handleCollapse, collapseStates } = props;
  const [isOpen, setIsOpen] = React.useState(false);
  const [unnestJobDetails, setUnnestJobDetails] = React.useState([]);
  const [, setUnnestJobInfo] = React.useState<any>(null);
  const reTriggerErrorUnNestedTriggerDataJob = async (subRow: any) => {
    autoRefresHJobAudit()
  };

  const reTriggerErrorUnNestedFillTriggerDataJob = async (item: any) => {
    //const userInput = item.user_inputs?.replace(/'/g, '"') || {}
    autoRefresHJobAudit()
  };

  const handleSubJobDataClick = async (subJob: any, dataSubJob: any) => {
    if (dataSubJob?.status === "Success") {
      console.log('click')
    }
  };

  const autoRefresHJobAudit = () => {
   console.log('refresh')
  }

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          {row?.subJobs && <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => handleCollapse(row.id)}
          >
            {collapseStates[row.id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>}
        </TableCell>
        <TableCell style={{ cursor: 'pointer' }} component="th" scope="row"
          onClick={() => handleHeaderDataClick(row)}
        >
          {row?.id}
        </TableCell>
        <TableCell style={{ cursor: 'pointer' }} onClick={() => handleHeaderDataClick(row)}>{row?.job_name}</TableCell>
        <TableCell style={{ cursor: 'pointer' }} onClick={() => handleHeaderDataClick(row)}>{row?.user_inputs}</TableCell>
        <TableCell style={{ cursor: 'pointer' }} onClick={() => handleHeaderDataClick(row)}>
          {getStatusElement(row?.status)}
        </TableCell>
        <TableCell style={{ cursor: 'pointer' }} onClick={() => handleHeaderDataClick(row)}>
          {row?.requestDateAndTime
            ? dayjs
              .utc(row?.requestDateAndTime as string)
              .tz(utz)
              .format("MMM DD, YYYY - hh:mm a")
            : ""}</TableCell>
        <TableCell style={{ cursor: 'pointer' }} onClick={() => handleHeaderDataClick(row)}>{customFormat(parseFloat(row?.processedTime))}</TableCell>
        <TableCell style={{ cursor: 'pointer' }} >
          <div style={{ display: 'flex' }}>
            {row?.status === 'Error' && <AutorenewIcon onClick={() => {
              reTriggerErrorHeaderDataJob(row)
            }} />}
            {row?.status === 'Inprogress' && <HighlightOffIcon />}
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={collapseStates[row.id]} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" fontWeight={"bold"} gutterBottom component="div">
                Sub Jobs
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    {jobAuditSubJobTableHeader &&
                      jobAuditSubJobTableHeader?.map((item: any) => (
                        <TableCell style={{ fontWeight: "600" }}>{item?.label}</TableCell>
                      ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row?.subJobs?.map((subRow: any, index: number) => (
                    <TableRow key={`subjob${index}`}>
                      <TableCell style={{ cursor: 'pointer' }} component="th" scope="row">
                        {subRow?.subJobs && <IconButton
                          aria-label="expand row"
                          size="small"
                          onClick={() => { setUnnestJobDetails(subRow?.subJobs || []); setUnnestJobInfo(subRow); setIsOpen(!isOpen) }}
                        >
                          {collapseStates[row.id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>}
                      </TableCell>
                      <TableCell
                        style={{ cursor: 'pointer' }} onClick={() => {
                          handleRawDataClick(subRow, row?.id)
                        }}
                        component="th" scope="row">
                        {subRow?.user_inputs && getSubJobType(subRow?.user_inputs)}
                      </TableCell>
                      <TableCell
                        style={{ cursor: 'pointer' }} onClick={() => {
                          handleRawDataClick(subRow, row?.id)
                        }} component="th" scope="row">
                        {subRow?.user_inputs && getJobName(subRow?.user_inputs)}
                      </TableCell>
                      <TableCell
                        style={{ cursor: 'pointer' }} onClick={() => {
                          handleRawDataClick(subRow, row?.id)
                        }} component="th" scope="row">
                        {subRow.id}
                      </TableCell>
                      <TableCell
                        style={{ cursor: 'pointer' }} onClick={() => {
                          handleRawDataClick(subRow, row?.id)
                        }} component="th" scope="row">
                        {subRow.user_inputs}
                      </TableCell>
                      <TableCell
                        style={{ cursor: 'pointer' }} onClick={() => {
                          handleRawDataClick(subRow, row?.id)
                        }} component="th" scope="row">
                        {getStatusElement(subRow?.status)}
                      </TableCell>
                      <TableCell
                        style={{ cursor: 'pointer' }} onClick={() => {
                          handleRawDataClick(subRow, row?.id)
                        }} component="th" scope="row">
                        {subRow?.requestDateAndTime ? dayjs
                          .utc(subRow?.requestDateAndTime as string)
                          .tz(utz)
                          .format("MMM DD, YYYY - hh:mm a")
                          : ""}
                      </TableCell>
                      <TableCell
                        style={{ cursor: 'pointer' }} onClick={() => {
                          handleRawDataClick(subRow, row?.id)
                        }} component="th" scope="row">
                        {customFormat(parseFloat(subRow.processedTime))}
                      </TableCell>
                      <TableCell style={{ cursor: 'pointer' }} component="th" scope="row">
                        <div style={{ display: 'flex' }}>
                          {subRow.status === 'Error' && <AutorenewIcon onClick={() => {
                            reTriggerErrorUnNestedTriggerDataJob(subRow)
                          }} />}
                          {subRow.status === 'Inprogress' && <HighlightOffIcon />}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        fullWidth={true}
        maxWidth={'xl'}
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          <Typography fontWeight={'600'}>Data Fault / Fill Jobs</Typography>
        </DialogTitle>
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          onClick={() => { setIsOpen(!isOpen) }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Box sx={{ margin: 1 }}>
            <Typography variant="h6" fontWeight={"bold"} gutterBottom component="div">
              Prepared Date
            </Typography>
            <Table size="small" aria-label="purchases">
              <TableHead>
                <TableRow>
                  {jobAuditSubSubJobTableHeader &&
                    jobAuditSubSubJobTableHeader?.map((item: any) => (
                      <TableCell style={{ fontWeight: "600" }}>{item?.label}</TableCell>
                    ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortJobAuditList(unnestJobDetails)?.map((subRow: any, index: number) => (
                  <TableRow key={`subjob${index}`}
                    onClick={() => {
                      if (subRow?.status) {
                        handleSubJobDataClick(subRow, subRow)
                      }
                    }}
                  >
                    <TableCell component="th" scope="row">
                      {subRow?.user_inputs && getSubJobType(subRow?.user_inputs)}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {subRow.id}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {subRow.user_inputs}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {getStatusElement(subRow?.status)}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {subRow?.requestDateAndTime ? dayjs
                        .utc(subRow?.requestDateAndTime as string)
                        .tz(utz)
                        .format("MMM DD, YYYY - hh:mm a")
                        : ""}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {customFormat(parseFloat(subRow.processedTime))}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <div style={{ display: 'flex' }}>
                        {subRow.status === 'Error' && <AutorenewIcon onClick={() => {
                          reTriggerErrorUnNestedFillTriggerDataJob(subRow)
                        }}
                        />}
                        {subRow.status === 'Inprogress' && <HighlightOffIcon />}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}

export default function CollapsibleTable({ headData, auditList, handleHeaderDataClick, handleRawDataClick }: any) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [collapseStates, setCollapseStates] = React.useState({});
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
    resetCollapseStates();
  };
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    resetCollapseStates();
  };

  const handleCollapse = (rowId: any) => {
    setCollapseStates((prev: any) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  const resetCollapseStates = () => {
    setCollapseStates({});
  };

  const reTriggerErrorHeaderDataJob = async (data: any) => {
    let payload: any = {
      inputType: 's3',
      jobName: data?.job_name,
      userInput: [],
    };
    const userInput = data?.user_inputs?.replace(/'/g, '"');
    JSON.parse(userInput)?.forEach((item: any) => {
      payload.userInput.push(item)
    })
  }


  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              {headData &&
                headData?.map((item: any) => (
                  item?.id === 'status' ? <TableCell style={{ fontWeight: "600" }}>{item?.label} <MaxToolTip content={JobStatusFillToolTipContent} /></TableCell> : <TableCell style={{ fontWeight: "600" }}>{item?.label}</TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {auditList && auditList?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              ?.map((row: any, index: number) => (
                <Row key={index} row={row} handleHeaderDataClick={handleHeaderDataClick}
                  handleRawDataClick={handleRawDataClick}
                  reTriggerErrorHeaderDataJob={reTriggerErrorHeaderDataJob}
                  collapseStates={collapseStates}
                  handleCollapse={handleCollapse} />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10]}
        component="div"
        count={auditList?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /></>
  );
}